import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from './generic.service';

@Injectable({
	providedIn: 'root',
})
export class UserManagementService extends GenericService<any> {
	private http1 = inject(HttpClient);

	constructor() {
		super();
		this.endpoint = 'roles';
		this.ACTIONS = {
			list: 'ROLE_LIST',
			add: 'ROLE_ADD',
			update: 'ROLE_UPDATE',
			delete: 'ROLE_DELETE',
			item: 'ROLE_ITEM',
		};
	}

	getManyCompanyUser = (companyUuid: any, params: {}) => {
		this.endpoint = `companies/${companyUuid}/user-management`;
		return super.list(params);
	};

	removeUserRole = (companyUuid: any, roleUuid: any) => {
		this.endpoint = `companies/${companyUuid}/user-management`;
		return super.delete(roleUuid);
	};

	inviteUserToCompany = (companyUuid: any, body: any) => {
		this.endpoint = `companies/${companyUuid}/user-management`;
		return super.add(body);
	};

	updateUserRole = (companyUuid: any, userRoleUuid: any, role: any, active: boolean) => {
		this.endpoint = `companies/${companyUuid}/user-management/${userRoleUuid}`;
		return super.patch({ role, active });
	};
}
